export default [
  {
    path: 'period',
    name: 'period',
    component: () => import('@/views/pages/period/Period.vue'),
    meta: {
      pageTitle: 'Period',
      breadcrumb: [
        {
          text: 'Period',
          active: true,
        },
      ],
      resource: 'All',
    },
  },
  {
    path: 'period/:id',
    name: 'period-view',
    component: () => import('@/views/pages/period/View.vue'),
    meta: {
      pageTitle: 'Periods',
      breadcrumb: [
        {
          to: { name: 'period' },
          text: 'Periods',
          active: false,
        },
        {
          text: 'Period',
          active: true,
        },
      ],
      resource: 'All',
    },
  },
]
